// extracted by mini-css-extract-plugin
module.exports = {"banner":"FirstTutorsBanner_banner__h3vm4","inner":"FirstTutorsBanner_inner__srG_E","link":"FirstTutorsBanner_link__HIWuv"};